import { render, staticRenderFns } from "./folder-structure-tree.vue?vue&type=template&id=1a345c42&scoped=true"
import script from "./folder-structure-tree.vue?vue&type=script&lang=js"
export * from "./folder-structure-tree.vue?vue&type=script&lang=js"
import style0 from "./folder-structure-tree.vue?vue&type=style&index=0&id=1a345c42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a345c42",
  null
  
)

export default component.exports